//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import findKey from 'lodash/findKey';
import findIndex from 'lodash/findIndex';
import isMatch from 'lodash/isMatch';
import reduce from 'lodash/reduce';
import map from 'lodash/map';
import flatMap from 'lodash/flatMap';
import FieldMixin from './FieldMixin';

export default {

	mixins: [FieldMixin],

	props: {
		showModifications: {
			type: Boolean,
			default: true
		}
	},

	computed: {

		skuProps()
		{
			return this.$store.getters[`${this.$root.$namespace}/getSkuPropsByIblockId`](this.row.iblockId);
		},

		treeProps()
		{
			return this.skuProps.filter(prop => this.propsValues[prop.ID]);
		},

		propsValues()
		{
			return this.row.sku;
		},

		disabledValues()
		{
			return flatMap(this.propsValues, (values, propId) => {
				return reduce(values, (result, value, valueId) => {
					if (!!!this.findProduct(propId, parseInt(valueId)))
						result.push(propId + '_' + valueId);

					return result;
				}, []);
			});
		},

		cantBuyValues()
		{
			return flatMap(this.treeProps, prop => {
				return Object.keys(this.propsValues[prop.ID])
					.filter(valueId => !this.isDisabled(prop.ID, valueId))
					.reduce((result, strValueId) => {
						const valueId = parseInt(strValueId);
						if (!this.findProduct(prop.ID, valueId, true))
							result.push(valueId);

						return result;
					}, []);
			});
		},

		formattedPropsValues()
		{
			return this.skuProps
				.filter(prop => this.propsValues[prop.ID])
				.map(prop => ({
					ID: prop.ID,
					NAME: prop.NAME,
					SHOW_MODE: prop.SHOW_MODE,
					values: Object.values(prop.VALUES)
						.filter(value => this.propsValues[prop.ID][value.ID] && !this.isDisabled(prop.ID, value.ID))
						.sort((v1, v2) => v1.SORT - v2.SORT)
				}));
		},

		images()
		{
			return ((this.$root.params || {}).imagesPath) || {};
		},

		messages()
		{
			return Object.freeze({
				'RS_B2B_CS_SHOW_MODIFICATIONS': BX.message('RS_B2B_CS_SHOW_MODIFICATIONS'),
				'RS_B2B_CS_HIDE_MODIFICATIONS': BX.message('RS_B2B_CS_HIDE_MODIFICATIONS')
			});
		},

		spritePath()
		{
			return B2BPortal.config.spritePath;
		},
	},

	methods: {

		isDisabled(propId, valueId)
		{
			return this.disabledValues.includes(propId + '_' + valueId);
		},

		cantBuy(valueId)
		{
			return this.cantBuyValues.includes(valueId);
		},

		select(propId, valueId)
		{
			if (!this.isDisabled(propId, valueId))
			{
				this.row.selected = this.findNearestProduct(propId, valueId, !this.cantBuy(valueId)) || this.row.selected;
			}
		},

		getFilter(propId, valueId, index = 0)
		{
			const filter = {};

			if (index > this.treeProps.length)
			{
				index = this.treeProps.length;
			}

			for (let i = 0, strPropName = ''; i < index; i++)
			{
				strPropName = 'PROP_' + this.treeProps[i].ID;
				filter[strPropName] = this.product.tree[strPropName];
			}

			filter['PROP_' + propId] = valueId;

			return filter;
		},

		findProductByFilter(filter, canBuy = false)
		{
			if (canBuy)
			{
				return findKey(this.row.products, product => isMatch(product.tree, filter) && product.canBuy);
			}
			else
			{
				return findKey(this.row.products, product => isMatch(product.tree, filter));
			}
		},

		findNearestProduct(propId, valueId, canBuy = false)
		{
			let productId = false;

			for (let i = this.treeProps.length, filter; i >= 0; i--)
			{
				productId = this.findProductByFilter(this.getFilter(propId, valueId, i), canBuy);

				if (productId)
				{
					break;
				}
			}

			return productId;
		},

		findProduct(propId, valueId, canBuy = false)
		{
			const index = findIndex(this.skuProps, prop => prop.ID == propId);
			return -1 < index ? this.findProductByFilter(this.getFilter(propId, valueId, index), canBuy) : false;
		},
	}

}
